import { createAction } from "@reduxjs/toolkit";
import { NumberRange } from "shared/ui-kit";
import { ScreenerEtfBackendModel } from "../services/model";
import { ScreenerStoreFilter } from "./model";

export const dataEtfsLoaded = createAction<ScreenerEtfBackendModel[]>("SCREENER_DATA_ETFS_LOADED");
export const dataFilteredEtfsSet = createAction<ScreenerEtfBackendModel[]>("SCREENER_DATA_FILTEREDETFS_SET");
export const dataLoadingComplete = createAction<void>("SCREENER_DATA_LOADED");

export const filterSet = createAction<ScreenerStoreFilter>("SCREENER_FILTER_SET");
export const filterClear = createAction<void>("SCREENER_FILTER_CLEAR");
export const filterInputSetSelectFieldValue = createAction<{ systemName: string, value: string }>("SCREENER_FILTER_INPUT_SET_SELECTFIELDVALUE");
export const filterInputSetNumberRangeFieldValue = createAction<{ systemName: string, value: NumberRange }>("SCREENER_FILTER_INPUT_SET_NUMBERRANGEFIELDVALUE");

export const preferenceSetCurrency = createAction<string>("SCREENER_PREFERENCE_SET_CURRENCY");
export const preferenceSetConcreteEtfs = createAction<string[] | null>("SCREENER_PREFERENCE_SET_CONCRETEETFS");